import { useApigeeSnapshotFetchedAt } from '../../utils/apigeeSnapshotStatus';

// Shown above every page while any read is answered from saved data.
export default function ApigeeSnapshotNotice() {
  const fetchedAt = useApigeeSnapshotFetchedAt();
  if (!fetchedAt) return null;

  return (
    <div role="status" className="shrink-0 border-b border-amber-500/40 bg-amber-500/10 px-[22px] py-2 text-xs text-amber-300">
      The gateway runtime isn&apos;t responding. Showing data saved as of {new Date(fetchedAt).toLocaleString()}, so
      it may be out of date. Credentials are hidden, and changes won&apos;t go through until it&apos;s back.
    </div>
  );
}
